import MarketMavenIcon from "../assets/graphics/MarketMaven.png";
import { ReactComponent as YellowCheck } from "../assets/graphics/yellowcheck.svg";
import CoinConnoisseurIcon from "../assets/graphics/CoinConnoisseur.png";
import CryptoExplorerIcon from "../assets/graphics/CryptoExplorer.png";
import { ReactComponent as GreenCheck } from "../assets/graphics/greencheck.svg";
import { ReactComponent as BlueCheck } from "../assets/graphics/bluecheck.svg";

//temporary level numerator
export const level = 12;

export const arrayOfCards = [
  {
    id: 1,
    icon: MarketMavenIcon,
    title: "Market Maven",
    titleColor: "statusyellow",
    rankList: [
      {
        playerLevel: level,
        rank: 15,
        title: "All Coins and Indicators",
        ticked: <YellowCheck />
      },
      {
        playerLevel: level,
        rank: 14,
        title: "Additional Coins",
        ticked: <YellowCheck />
      },
      {
        playerLevel: level,
        rank: 13,
        title: "Additional Trade Slots",
        ticked: <YellowCheck />
      },
      {
        playerLevel: level,
        rank: 12,
        title: "Holding Strategy",
        ticked: <YellowCheck />
      },
      {
        playerLevel: level,
        rank: 11,
        title: "Volume Indicator",
        ticked: <YellowCheck />
      }
    ]
  },
  {
    id: 2,
    icon: CoinConnoisseurIcon,
    title: "Coin Connoisseur",
    titleColor: "statusgreen",
    rankList: [
      {
        playerLevel: level,
        rank: 10,
        title: "Enable/Disable Pause Trading",
        ticked: <GreenCheck />
      },
      {
        playerLevel: level,
        rank: 9,
        title: "Additional Coins",
        ticked: <GreenCheck />
      },
      {
        playerLevel: level,
        rank: 8,
        title: "Set Ticker Interval",
        ticked: <GreenCheck />
      },
      {
        playerLevel: level,
        rank: 7,
        title: "Expert View",
        ticked: <GreenCheck />
      },
      {
        playerLevel: level,
        rank: 6,
        title: "Enable/Disable Compound Trading",
        ticked: <GreenCheck />
      }
    ]
  },
  {
    id: 3,
    icon: CryptoExplorerIcon,
    title: "Crypto Explorer",
    titleColor: "statusblue",
    rankList: [
      {
        playerLevel: level,
        rank: 5,
        title: "Specify Trade Ratio",
        ticked: <BlueCheck />
      },
      {
        playerLevel: level,
        rank: 4,
        title: "Specify Trade Slots",
        ticked: <BlueCheck />
      },
      {
        playerLevel: level,
        rank: 3,
        title: "Top 10 Coin Picker",
        ticked: <BlueCheck />
      },
      {
        playerLevel: level,
        rank: 2,
        title: "Edit Quote Asset",
        ticked: <BlueCheck />
      },
      {
        playerLevel: level,
        rank: 1,
        title: "Skillful View",
        ticked: <BlueCheck />
      }
    ]
  }
];
